import { render } from "./Identifier.vue?vue&type=template&id=de1f9cf2"
import script from "./Identifier.vue?vue&type=script&lang=js"
export * from "./Identifier.vue?vue&type=script&lang=js"

import "./Identifier.vue?vue&type=style&index=0&id=de1f9cf2&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__